async function getMostSearchedCollections(locale,tree){
    const {first,second,third} = tree;
    let listOfSearchedCollection = [],collectionsBest = [],productsBest = [],bestCollectionThirdLevel = [],bestCollectionSecondLevel = [],bestCollectionFirstLevel = [];
    const protocol = window.location.protocol;
    const path = window.location.host;
    let productUrl,collectionUrl='';
    if(locale.length) {
        productUrl = protocol + '//' + path + '/' + locale + '/products/';
        collectionUrl= protocol + '//' + path + '/' + locale + '/collections/';
    }
    else{
        productUrl = protocol + '//' + path + '/products/';
        collectionUrl= protocol + '//' + path + '/collections/';
    }
    
    const response = await getBestSeller();
    const {products} = response.data;

    if (!products || products.length < 1) return;

    products.edges.forEach(product => {
        productsBest.push({
            handle:product.node.handle,
            id:product.node.id,
            title:product.node.title,
            url:productUrl + product.node.handle
        })
        product.node.collections.edges.forEach(collection => {
            collectionsBest.push(collection.node.handle)
        })
    })
    
    //const firstProductId = productsBest[0].id
   // const {productRecommendations} = await getRecommendedProducts(firstProductId);
    
    // Remove entry with same name
    collectionsBest = [...new Set(collectionsBest)]

    // Find the more specific collection
    bestCollectionThirdLevel = third.filter(element => collectionsBest.includes(element.handle));    
    bestCollectionSecondLevel = second.filter(element => collectionsBest.includes(element.handle));
    bestCollectionFirstLevel = first.filter(element => collectionsBest.includes(element.handle));

    bestCollectionThirdLevel.forEach((collection,i)=>{
        if ( collection && i < 4) listOfSearchedCollection.push(collection)
    })
    bestCollectionSecondLevel.forEach((collection,i)=>{
        if ( collection && i < 4) listOfSearchedCollection.push(collection)
    })
    bestCollectionFirstLevel.forEach((collection,i)=>{
        if ( collection && i < 4) listOfSearchedCollection.push(collection)
    })

    if ((!listOfSearchedCollection || !listOfSearchedCollection.length) &&
        (!collectionsBest.length || !collectionsBest.length)) {
            renderMostSearchedCollectionsMenu(null);
            return
        };
    
    renderMostSearchedCollectionsMenu(listOfSearchedCollection);
    renderMostSearchedProducts(productsBest)
}


function renderMostSearchedCollectionsMenu(collections){

    if(!collections){
        return;
    }

    const popdown = window.document.getElementById('search-popdown');
    const listColumns = window.document.querySelector('.js_search_column');
    const searchResultOuter = window.document.querySelector('[data-search-results-outer');

    if(!popdown || !listColumns || !searchResultOuter) return

    searchResultOuter.classList.add('active');

    collections.forEach((collection,i)=>{
        if( i < 4){
            const columnItem = document.createElement('div');
            columnItem.classList.add('search__results__item');
            const columnItemLink = document.createElement('a');
            columnItemLink.classList.add('search__results__link');
            columnItemLink.href = collection.url
            columnItemLink.innerHTML = collection.title

            columnItem.appendChild(columnItemLink)
            listColumns.appendChild(columnItem)
        }
    })
}

function renderMostSearchedProducts(productsBest){
    const productsContainer = window.document.querySelector('.js_products_container');
    const dataExclude = productsContainer?.getAttribute('data-result-to-exclude')?.replace('-'," ");
    let textToExclude = false;
    if (!productsBest.length || !productsContainer) return;

    if(dataExclude && dataExclude.length > 0) textToExclude = dataExclude;

    const handlers = productsBest.map(product => product.handle)
    renderProducts(0,handlers,productsContainer,3,textToExclude,'searchMenu')
        .then((res)=> {
            productsContainer.parentElement.style.display='block'}
            )
        .catch((e)=> productsContainer.parentElement.style.display='none')

}
